import { api } from "../../api";

export type PentesterFeedback = {
  pentester_id: number;
  technical_depth_rating: number;
  accuracy_rating: number;
  communication_rating: number;
  business_context_rating: number;
};

export type SubmitFeedbackRequest = {
  program_id: number;
  overall_program_rating: number;
  overall_program_comments?: string;
  pentester_feedbacks?: PentesterFeedback[];
  improvement_reasons?: string[];
  improvement_details?: string;
  next_step_option?: string;
  areas_needing_review?: string;
  requested_deadline?: string;
};

export type FeedbackStatusResponse = {
  has_feedback: boolean;
  feedback?: any;
  program_id: number;
};

export type ProgramNeedingFeedback = {
  program_id: number;
  run_id?: number;
  program_title: string;
  run_title?: string;
  expected_end_date: string;
  days_since_completion: number;
  has_feedback: boolean;
};

export const businessFeedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Submit or update program feedback
     */
    submitProgramFeedback: builder.mutation<
      { message: string; feedback: any },
      SubmitFeedbackRequest
    >({
      query: (data) => ({
        url: "/program-feedback/submit",
        method: "post",
        data
      }),
      invalidatesTags: ["Programs", "BusinessFeedback"]
    }),

    /**
     * Get feedback status for a specific program
     */
    getFeedbackStatus: builder.query<FeedbackStatusResponse, { programId: number, runId?: number }>({
      query: ({ programId, runId }) => ({
        url: "/program-feedback/status",
        method: "get",
        params: { program_id: programId, run_id: runId }
      }),
      providesTags: (result, error, arg) => [
        { type: "BusinessFeedback", id: arg.programId }
      ]
    }),

    /**
     * Get list of programs that need feedback
     */
    getProgramsNeedingFeedback: builder.query<
      { programs: ProgramNeedingFeedback[]; total: number },
      void
    >({
      query: () => ({
        url: "/program-feedback/programs-needing-feedback",
        method: "get"
      }),
      providesTags: ["BusinessFeedback"]
    })
  })
});

export const {
  useSubmitProgramFeedbackMutation,
  useGetFeedbackStatusQuery,
  useGetProgramsNeedingFeedbackQuery
} = businessFeedbackApi;

